var clevertap = {
    event: [],
    profile: [],
    account: [],
    onUserLogin: [],
    region: "in",
    notifications: []
  };
  // replace with the CLEVERTAP_ACCOUNT_ID with the actual ACCOUNT ID value from your Dashboard -> Settings page
  var clevertap_id = "TEST-468-4WR-955Z";
  if (window.location.hostname.split("-")[0] + "-w" == "dev-w") {
    clevertap_id = "TEST-468-4WR-955Z";
  } else if ((window.location.hostname.split("-")[0] + "-w" == "sit-w") || (window.location.hostname.split("-")[0] + "-w" == "newsit-w")) {
    clevertap_id = "TEST-884-76K-R45Z";
  } else if (window.location.hostname.split("-")[0] + "-w" == "pp-w") {
    clevertap_id = "TEST-656-6RZ-545Z";
  } else if(window.location.hostname == 'localhost'){
    clevertap_id = "TEST-884-76K-R45Z";
  } else {
    clevertap_id = "6ZR-967-584Z";
  }
  clevertap.account.push({
    "id": clevertap_id
  });
  (function() {
    var wzrk = document.createElement('script');
    wzrk.type = 'text/javascript';
    wzrk.async = true;
    wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wzrk, s);
  })();
 